/* src/app/system-utils/input-autocomplete/input-autocomplete.component.scss */
.auto-complete {
  position: relative;
  width: 100%;
}
.tem-field {
  width: 100%;
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.clear-icon:hover {
  color: var(--tem-ink);
}
/*# sourceMappingURL=input-autocomplete.component.css.map */
